import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";

export const SchemaOrganization = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "Organization",
        url: getOrigin(),
        logo: {
          "@type": "ImageObject",
          url: `${getOrigin()}/logo.png`,
          height: "78",
          width: "137"
        },
        name: replaceSnappTripBasedOnChannel("اسنپ تریپ"),
        sameAs: isChannel(["snapp-ir"])
          ? [
              "https://www.instagram.com/snapp_team",
              "https://twitter.com/snapp_team",
              "https://www.linkedin.com/company/snapp.ir"
            ]
          : [
              "https://www.instagram.com/snapptrip",
              "https://twitter.com/snapptrip",
              "https://www.linkedin.com/company/snapptrip-com"
            ]
      })
    }}
    type="application/ld+json"
  />
);
